import { render, staticRenderFns } from "./QuestionShortText.vue?vue&type=template&id=08f700ec&"
import script from "./QuestionShortText.vue?vue&type=script&lang=js&"
export * from "./QuestionShortText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports